export default "__VITE_PUBLIC_ASSET__136c9fa6__"